import styled, { css } from 'styled-components'
import { IText } from './index'

const globalCss = css<IText>(
  ({ theme, size, weight, uppercase, underline, ellipsis, nowrap, align, color, marginBottom, marginTop }) => css`
    line-height: 1.5;

    ${size === 'sm' &&
    css`
      font-size: 12px;
      line-height: 1.3;

      ${theme.breakpoints.up(1024)} {
        font-size: 12px;
        line-height: 1.5;
      }
    `}

    ${size === 'lg' &&
    css`
      font-size: 20px;
      line-height: 1.6;
    `}

    ${weight === 'bold' &&
    css`
      font-weight: ${weight};
    `}

    ${uppercase &&
    css`
      text-transform: uppercase;
    `}

    ${underline &&
    css`
      text-decoration: underline;
    `}

    ${ellipsis &&
    css`
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    `}

    ${align &&
    css`
      text-align: ${align};
    `}

    ${nowrap &&
    css`
      white-space: nowrap;
    `}

    ${color &&
    css`
      color: ${theme.colors[color]};
    `}

    ${marginBottom &&
    css`
      margin-bottom: ${marginBottom}px;
    `}

    ${marginTop &&
    css`
      margin-top: ${marginTop}px;
    `}
  `
)

export const StyledParagraph = styled.p<IText>`
  ${globalCss}
`

export const StyledText = styled.span<IText>`
  ${globalCss}
`
